import { HostSystemItemSortType } from "@tlc/ls2pac/dto/HostSystemItemSortType";
import { isHoldsSortType } from "../HostSystemItemSortControl";
import { LoaderFunctionArgs } from "react-router-dom";

export const holdsLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const sortParam = url.searchParams.get("sort");
  const sort = isHoldsSortType(sortParam)
    ? sortParam
    : HostSystemItemSortType.Status;
  const page = url.searchParams.has("page")
    ? parseInt(url.searchParams.get("page"))
    : 0;
  const pageSize = url.searchParams.has("size")
    ? parseInt(url.searchParams.get("size"))
    : 10;
  const refreshToken = Date.now();

  return {
    sort,
    page,
    pageSize,
    refreshToken,
  };
};
